import { ExperimentProviderContext } from '@carvana/experiment';
import { useContext, useMemo } from 'react';
import {
  browserCookieIdExperiments,
  mobileOnlyExperiments
} from '~/constants/srp/experiments';

export default function useReportedBrowserCookieIdExperiments() {
  const { experiments } = useContext(ExperimentProviderContext);

  return useMemo(
    () => ({
      ...browserCookieIdExperiments,
      ...Object.fromEntries(
        Object.entries(mobileOnlyExperiments).filter(
          ([name]) => name in experiments
        )
      )
    }),
    [experiments]
  );
}
